export enum ActionType {
    ADD_TO_CART = "add-to-cart",
    ADVISOR = "advisor",
}
